/**
 * Responsável por adicionar os markers de Stops no mapa.
 * Created by adalto on 5/7/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.Stops = (function () {

    function Stops () {

        Greenmile.Toolbar.MapLayerActions.Base.apply(this, arguments);

        this.LAYER_NAME = 'stops';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.Locations';

        var instanceToDataClass = null;

        this.setInstanceToClassData = function (instance) {
            instanceToDataClass = instance;
        };

        this.afterClickOnCheckBox = (element) => {
          const status = !!element.target.checked;
          this.setLayerStatusOnLocalStorageByTagName(status);

          if (instanceToDataClass) {
            if (status) {
              instanceToDataClass.getStopsAndDrawOnMap();
            } else {
              instanceToDataClass.removeStopsFromMap();
              if (instanceToDataClass.closePopup) {
                instanceToDataClass.closePopup();
              }
            }
          }
          this.fireEvent('afterClickOnCheckBox');
        };
    }
    return Stops;
}());
